export const abTests = {
	IXO_IN_PRODUCT_EXPERIENCE: {
		testName: '2022-01-27_ixo_in_product_experience',
		inGroup: 'SHOW_IXO',
		controlGroup: 'CONTROL-NO_IXO'
	},
	GROWTH_GOALS_MONTHLY_SUGGESTION: {
		testName: '2022-01-25_growth_goals_monthly_suggestion',
		inGroup: 'SHOW_MONTHLY_SUGGESTIONS',
		controlGroup: 'CONTROL-EXISTING_GOAL_AMOUNT'
	},
	AUTO_INVEST_DISABLE_MODAL_COPY: {
		testName: '2022-05-01_auto_invest_disable_copy_test',
		inGroup: 'GROWTH_CALC_CTA',
		controlGroup: 'CONTROL'
	}
};
